import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    $onInit() {
        this.usageReport = this.resolve.usageReport;
        this.st = new SmartTable();
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/sms-usage-report/sms-usage-report.controller.js